const styles = {
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  container: provided => ({
    ...provided,
    fontFamily: "'EYInterstate', sans-serif",
    fontSize: '14px',
    color: '#333',
    width: '100%',
    outline: 'none',
  }),
  control: (provided, state) => ({
    ...provided,
    width: '100%',
    backgroundColor: '#F6F6FA',
    borderRadius: 0,
    minHeight: '34px',
    border: 'none',
    boxShadow: null,
  }),
  placeholder: (provided, state) => {
    let isTopText = state.hasValue || state.selectProps.menuIsOpen || state.selectProps.inputValue;
    return {
      ...provided,
      display: 'block !important',
      top: isTopText ? 'calc(50% - 8px)' : 'auto',
      left: '8px',
      width: 'calc(100% - 12px)',
      position: 'absolute',
      fontSize: isTopText ? '1rem' : '14px',
      transition: 'transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
      fontFamily: 'EYInterstate',
      transformOrigin: 'top left',
      color: '#747480',
      transform: isTopText ? 'translate(0, -8px) scale(0.75)' : 'none',
      whiteSpace: isTopText ? 'nowrap' : 'normal',
    };
  },
  option: (provided, state) => {
    let backgroundColor;
    if (state.isFocused) {
      backgroundColor = '#F6F6FA';
    } else if (state.isSelected) {
      backgroundColor = 'rgba(0, 126, 255, 0.04)';
    } else {
      backgroundColor = '#fff';
    }

    return {
      ...provided,
      backgroundColor: backgroundColor,
      color: state.isFocused || state.isSelected ? '#333' : '#666666',
      padding: '12px',
      display: 'flex',
      '&:active': {
        backgroundColor: '#F6F6FA',
      },
    };
  },
  singleValue: (provided, state) => ({
    ...provided,
    color: 'black',
    top: state.hasValue || state.selectProps.inputValue ? '65%' : '50%',

    '.value-searchadd, .value-serviceinit, .value-case': {
      marginLeft: '2rem',
    },
  }),
  multiValue: (provided, state) => ({
    ...provided,
    top: state.hasValue || state.selectProps.inputValue ? '65%' : '50%',
  }),
  multiValueLabel: base => ({
    ...base,
    backgroundColor: '#FFF',
    padding: '2px 3px',
    color: '#000',

    '.item-email': {
      color: '#188CE5',
    },
  }),
  multiValueRemove: base => ({
    ...base,
    backgroundColor: '#FFF',
    '&:hover': {
      backgroundColor: '#FFF',
    },

    '.del-icon': {
      fontSize: '16px',
      marginLeft: '3px',
      cursor: 'pointer',
      verticalAlign: 'middle',
      color: '#747480',
      paddingBottom: '1px',
    },
  }),
  clearIndicator: (provided, state) => ({
    ...provided,
    cursor: 'pointer',
    color: '#666',
  }),
};

export default styles;
